import { $body, Breakpoints } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * BannerCta
 */
const BannerCta = (($) => {
  // Constants
  const DATA_KEY = 'ig.banner-cta';
  const EVENT_KEY = `.${DATA_KEY}`;
  const MOBILE_BREAKPOINT = Breakpoints.LARGE;

  /**
   * Selector
   */
  const Selector = {
    BANNER_CTA: '.banner-cta'
  };

  /**
   * BannerCta
   *
   * @class
   * @augments HtmlElement
   */
  class BannerCta extends HtmlElement {
    // Getters

    /**
     * Returns the MOBILE_BREAKPOINT constant
     *
     * @static
     * @return { String } MOBILE_BREAKPOINT
     */
    static get MOBILE_BREAKPOINT() {
      return MOBILE_BREAKPOINT;
    }
  }

  return BannerCta._getElement($body.find(Selector.BANNER_CTA), BannerCta);
})();

export default BannerCta;
